import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Input, { INPUT_TYPES } from '../Input/Input';
import Button from '../Button/Button';
import { Add, Remove } from '@material-ui/icons';
import FancyToggleSmall from '../FancyToggle/FancyToggleSmall';

export default  class TimeRow extends Component {
  static propTypes = {
    rowLabel: PropTypes.string.isRequired,
    templateType: PropTypes.string.isRequired,
    templateIndex: PropTypes.number.isRequired,
    inputPathPrefix: PropTypes.string.isRequired,
    valueSource: PropTypes.object.isRequired,
    timeRowInputFieldUpdate: PropTypes.func.isRequired,
    timeRowIndex: PropTypes.number,
  };

  render() {
    const {
      templateIndex,
      inputPathPrefix,
      valueSource,
      timeRowInputFieldUpdate,
      timeRowIndex,
    } = this.props;
    return (
      <li className="flex items-end justify-between mt-2">
        <div className="text-xs pb-2 font-medium w-32">
          {this.props.rowLabel}
        </div>
        <div className="flex items-end mr-8">
          <Input
            id={`${inputPathPrefix}.openingHour`}
            name={`${inputPathPrefix}.openingHour`}
            type={INPUT_TYPES.SELECT}
            value={valueSource.openingHour}
            onChange={timeRowInputFieldUpdate}
            options={this.props.hourRange}
            label={this.props.isFirstBracket ? 'FROM' : ''}
            className="mr-1 w-16"
            labelClassName="time_bracket_input_label font-medium"
            inputClassName="bg-almostWhite shadow-inner h-6"
            defaultHeight={false}
          />
          <div className="mr-1 leading-normal">:</div>
          <Input
            id={`${inputPathPrefix}.openingMinute`}
            name={`${inputPathPrefix}.openingMinute`}
            type={INPUT_TYPES.SELECT}
            value={valueSource.openingMinute}
            onChange={timeRowInputFieldUpdate}
            options={this.props.minutesRange}
            inputClassName="bg-almostWhite shadow-inner h-6"
            defaultHeight={false}
            className="w-16"
          />
        </div>
        <div className="flex items-end">
          <Input
            id={`${inputPathPrefix}.closingHour`}
            name={`${inputPathPrefix}.closingHour`}
            type={INPUT_TYPES.SELECT}
            value={valueSource.closingHour}
            onChange={timeRowInputFieldUpdate}
            options={this.props.hourRange}
            label={this.props.isFirstBracket ? 'TO' : ''}
            className="mr-1 w-16"
            labelClassName="time_bracket_input_label font-medium"
            inputClassName="bg-almostWhite shadow-inner h-6"
            defaultHeight={false}
          />
          <div className="mr-1 leading-normal">:</div>
          <Input
            id={`${inputPathPrefix}.closingMinute`}
            name={`${inputPathPrefix}.closingMinute`}
            type={INPUT_TYPES.SELECT}
            value={valueSource.closingMinute}
            onChange={timeRowInputFieldUpdate}
            options={this.props.minutesRange}
            inputClassName="bg-almostWhite shadow-inner h-6"
            defaultHeight={false}
            className="w-16"
          />
        </div>
        <div className="flex items-end">
          <FancyToggleSmall
            className="mr-4 w-16"
            toggleLabelClassName="time_bracket_input_label font-medium"
            id={`${inputPathPrefix}.wholeDay`}
            name={`${inputPathPrefix}.wholeDay`}
            label={this.props.isFirstBracket ? 'Whole-Day' : ''}
            checked={valueSource.wholeDay}
            onChange={timeRowInputFieldUpdate}
            onText="YES"
            offText="NO"
          />
          <FancyToggleSmall
            className="w-16"
            toggleLabelClassName="time_bracket_input_label font-medium"
            id={`${inputPathPrefix}.dayOff`}
            name={`${inputPathPrefix}.dayOff`}
            label={this.props.isFirstBracket ? 'Day-Off' : ''}
            checked={valueSource.dayOff}
            onChange={timeRowInputFieldUpdate}
            onText="YES"
            offText="NO"
          />
        </div>
        {this.props.templateType === 'CUSTOM' && (
          <div className="flex items-end">
            <span>
              <Button
                onClick={() => this.props.onAddDay(templateIndex, timeRowIndex)}
                type="transparent"
                className="p-0-important shadow-none-important ml-4">
                <Add className="bg-lightRed text-red rounded-full" />
              </Button>
            </span>
            <span> </span>
            <span>
              <Button
                onClick={() =>
                  this.props.onRemoveDay(templateIndex, timeRowIndex)
                }
                type="transparent"
                className="p-0-important shadow-none-important ml-4">
                <Remove className="bg-lightRed text-red rounded-full" />
              </Button>
            </span>
          </div>
        )}
      </li>
    );
  }
}
